import { render, staticRenderFns } from "./PermissionGroupForm.vue?vue&type=template&id=69799d22&"
import script from "./PermissionGroupForm.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroupForm.vue?vue&type=style&index=0&id=69799d22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports